import type { SubscriptionStatus } from '../../api/types';
import type { Tone } from '../ui';

/** Colour for a subscription's lifecycle status. */
export function subscriptionTone(status: SubscriptionStatus): Tone {
  return status === 'ACTIVE' || status === 'TRIALING'
    ? 'ok'
    : status === 'PAST_DUE'
      ? 'warn'
      : 'neutral';
}

/** "past due", "trialing": the status as a person reads it. */
export function subscriptionLabel(status: SubscriptionStatus): string {
  return status.toLowerCase().replace('_', ' ');
}
